import GlobalScheduleV2Page from './_modules/global-schedule/global-schedule-page-v2';

const Schedule = new GlobalScheduleV2Page();

export default class GlobalScheduleV2 {
    constructor() {
      this.init();
    }
  
    init() {
      //
    }
  }